import { IBrandingProvider } from "../IBrandingProvider";

export class GTBranding implements IBrandingProvider {
    getLogo(): string {
      return require('../../assets/Icons/GTLogo.png');
    }
    getPrimaryColor(): string {
      return "#231F20";
    }
  }
  